class VariantSelector extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.section = this.closest('.js-product');
    this.productForm = this.section.querySelector('.js-product-form');
    this.optionsForm = this.querySelector('form.options-form');
    if(!this.optionsForm) return;
    this.selectedOptions = window.Shopify.theme.selectedOptions;
    this.updateDeeplinking(true);
    this.getProductData().then(() => {
      this.renderSelector();
      this.updateOptionValues();
      this.setEventListeners();
    });
  }
  getScrollbarWidth() {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    outer.style.msOverflowStyle = 'scrollbar';
    document.body.appendChild(outer);
    const inner = document.createElement('div');
    outer.appendChild(inner);
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
  }
  enableScroll() {
    document.body.style.position = null;
    document.body.style.top = null;
    document.body.style.overflow = null;
    document.body.style.paddingRight = null;
    document.documentElement.scrollTop = document.body.scrollTop = this.scrollPos;
    document.documentElement.style.setProperty('--page-translate-x', '0px');
    this.classList.remove('active');
    document.querySelectorAll('clever-slider').forEach(slider => {
      if(!!slider.embla){
        slider.embla.reInit();
      }
    });
  }
  disableScroll() {
    this.scrollPos = (document.documentElement.scrollTop || document.body.scrollTop)
    document.body.style.position = 'fixed';
    document.body.style.top = (this.scrollPos * -1)+'px';
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = this.getScrollbarWidth()+'px';
    document.documentElement.style.setProperty('--page-translate-x', '-375px');
    this.classList.add('active');
  }
  openOption(option) {
    const optionID = option.dataset.optionId;
    const toggles = this.section.querySelectorAll('[data-open-option="'+optionID+'"]');
    toggles.forEach(toggle => {
      toggle.classList.add('active');
    });
    option.classList.add('active');
  }
  closeOption(option) {
    const optionID = option.dataset.optionId;
    const toggles = this.section.querySelectorAll('[data-open-option="'+optionID+'"]');
    toggles.forEach(toggle => {
      toggle.classList.remove('active');
    });
    option.classList.remove('active');
  }
  async getVariantData() {
    const query = `
    query ContextualizedProduct($id: ID!, $selectedOptions: [SelectedOptionInput!]!, $country: CountryCode, $language: LanguageCode) @inContext(country: $country, language: $language) {
      product(id: $id) {
        selectedOrFirstAvailableVariant(selectedOptions: $selectedOptions, caseInsensitiveMatch: true) {
          id
          title
          sku
          availableForSale
          currentlyNotInStock
          price {
            amount
          }
          compareAtPrice {
            amount
          }
          unitPrice {
            amount
          }
          unitPriceMeasurement {
            referenceUnit
            referenceValue
          }
          selectedOptions {
            name
            value
          }
          description: metafield(namespace: "vmeta", key: "description_text") {
            value
          }
          disclaimer: metafield(namespace: "variant_meta", key: "disclaimer") {
            value
          }
          data_sheets: metafield(namespace: "variant_meta", key: "data_sheets") {
            value
          }
          scalePricesSerbia: metafield(namespace: "strauss", key: "scale_prices_RSD") {
            value
          }
          scalePricesDefault: metafield(namespace: "variant_meta", key: "scale_price_clean") {
            value
          }
          sizeName: metafield(namespace: "variant_meta", key: "SizeName") {
            value
          }
          variantSwatch: metafield(namespace: "variant_meta", key: "ColorSwatch") {
            reference {
              ... on Metaobject {
                name: field(key: "ColorName") {
                  value
                }
                image: field(key: "ColorIconURL") {
                  reference {
                    ... on MediaImage {
                      id
                      alt
                      image {
                        url
                        altText
                      }
                    }
                  }
                }
              }
            }
          }
          variantImage: metafield(namespace: "variant_meta", key: "variant_images") {
            references(first: 1) {
              nodes {
                ... on MediaImage {
                  id
                }
              }
            }
          }
        }
      }
    }
    `
    const variables = {id: `gid://shopify/Product/${this.dataset?.productId}`, selectedOptions: this.selectedOptions, country: window.Shopify.country.toUpperCase(), language: window.Shopify.locale.toUpperCase()};
    return fetch(window.Shopify.storefrontApiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': window.Shopify.storefrontApiToken
      },
      body: JSON.stringify({ query, variables })
    })
    .then(response => response.json())
    .then(response => {
      this.currentVariant = response?.data?.product?.selectedOrFirstAvailableVariant ?? null;
      if(this.currentVariant) {
        const formatted_variante_id = this.currentVariant.id.split('/').pop();
        this.currentVariant.id = formatted_variante_id;
      }
      return response;
    }).catch(error => {
      this.currentVariant = null;
      console.error(error);
    });
  }
  async getProductData() {
    const query = `
    query ContextualizedProduct($id: ID!, $selectedOptions: [SelectedOptionInput!]!, $country: CountryCode, $language: LanguageCode) @inContext(country: $country, language: $language) {
      product(id: $id) {
        id
        title
        handle
        descriptionHtml
        encodedVariantAvailability
        encodedVariantExistence
        selectedOrFirstAvailableVariant(selectedOptions: $selectedOptions, caseInsensitiveMatch: true) {
          id
          title
          sku
          availableForSale
          currentlyNotInStock
          price {
            amount
          }
          compareAtPrice {
            amount
          }
          unitPrice {
            amount
          }
          unitPriceMeasurement {
            referenceUnit
            referenceValue
          }
          selectedOptions {
            name
            value
          }
          scalePricesSerbia: metafield(namespace: "strauss", key: "scale_prices_RSD") {
            value
          }
          scalePricesDefault: metafield(namespace: "variant_meta", key: "scale_price_clean") {
            value
          }
          sizeName: metafield(namespace: "variant_meta", key: "SizeName") {
            value
          }
          variantSwatch: metafield(namespace: "variant_meta", key: "ColorSwatch") {
            reference {
              ... on Metaobject {
                name: field(key: "ColorName") {
                  value
                }
                image: field(key: "ColorIconURL") {
                  reference {
                    ... on MediaImage {
                      id
                      alt
                      image {
                        url
                        altText
                      }
                    }
                  }
                }
              }
            }
          }
          variantImage: metafield(namespace: "variant_meta", key: "variant_images") {
            references(first: 1) {
              nodes {
                ... on MediaImage {
                  id
                }
              }
            }
          }
        }
        options {
          id
          name
          optionValues {
            id
            name
            firstSelectableVariant {
              id
              title
              sizeType: metafield(namespace: "variant_meta", key: "SizeType") {
                value
              }
              sizeName: metafield(namespace: "variant_meta", key: "SizeName") {
                value
              }
              variantSwatch: metafield(namespace: "variant_meta", key: "ColorSwatch") {
                reference {
                  ... on Metaobject {
                    name: field(key: "ColorName") {
                      value
                    }
                    image: field(key: "ColorIconURL") {
                      reference {
                        ... on MediaImage {
                          id
                          alt
                          image {
                            url
                            altText
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    `
    const variables = {id: `gid://shopify/Product/${this.dataset?.productId}`, selectedOptions: this.selectedOptions, country: window.Shopify.country.toUpperCase(), language: window.Shopify.locale.toUpperCase()};
    return fetch(window.Shopify.storefrontApiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': window.Shopify.storefrontApiToken
      },
      body: JSON.stringify({ query, variables })
    })
    .then(response => response.json())
    .then(response => {
      this.product = response?.data?.product ?? null;
      this.currentVariant = response?.data?.product?.selectedOrFirstAvailableVariant ?? null;
      if(this.currentVariant) {
        const formatted_variante_id = this.currentVariant.id.split('/').pop();
        this.currentVariant.id = formatted_variante_id;
      }
      return response;
    }).catch(error => {
      this.product = null;
      console.error(error);
    });
  }
  /**
   * Determine whether an option value combination is present in an encoded option value string. Function is memoized by encodedVariantField.
   *
   * @param optionValueCombination - Indices of option values to look up in the encoded option value string. A partial set of indices may be passed to determine whether a node or any children is present. For example, if a product has 3 options, passing [0] will return true if any option value combination for the first option's option value is present in the encoded string.
   * @param encodedVariantField - Encoded option value string from the Storefront API, e.g. [product.encodedVariantExistence](/docs/api/storefront/2026-01/objects/Product#field-encodedvariantexistence) or [product.encodedVariantAvailability](/docs/api/storefront/2026-01/objects/Product#field-encodedvariantavailability)
   * @returns - True if a full or partial targetOptionValueIndices is present in the encoded option value string, false otherwise.
   */
  isOptionValueCombinationInEncodedVariant(optionValueCombination, encodedVariantField) {
    const OPTION_VALUE_SEPARATOR = ',';
    const V1_CONTROL_CHARS = {
      OPTION: ':',
      END_OF_PREFIX: ',',
      SEQUENCE_GAP: ' ',
      RANGE: '-',
    };
    /**
     * For an encoded option value string, decode into option value combinations. Entries represent a valid combination formatted as an array of option value positions.
     * @param encodedVariantField - Encoded option value string from the Storefront API
     * @returns Decoded option value combinations
     */
    function decodeEncodedVariant(encodedVariantField) {
      function v1Decoder(encodedVariantField) {
        const tokenizer = /[ :,-]/g;
        let index = 0;
        let token;
        const options = [];
        const currentOptionValue = [];
        let depth = 0;
        let rangeStart = null;

        // iterate over control characters
        while ((token = tokenizer.exec(encodedVariantField))) {
          const operation = token[0];
          const optionValueIndex =
            Number.parseInt(encodedVariantField.slice(index, token.index)) || 0;

          if (rangeStart !== null) {
            // If a range has been started, iterate over the range and add each option value to the list of options
            // - `rangeStart` is set if the last control char was a dash, e.g. `0` for 0-2. It represents the numeric option value position for the start of the range.
            // - `optionValueIndex` is the numeric option value position for the end of the range
            for (; rangeStart < optionValueIndex; rangeStart++) {
              currentOptionValue[depth] = rangeStart;
              options.push([...currentOptionValue]);
            }
            // indicates the range has been processed
            rangeStart = null;
          }

          currentOptionValue[depth] = optionValueIndex;

          if (operation === V1_CONTROL_CHARS.RANGE) {
            // dash operation indicates we are in a range. e.g. 0-2 means option values 0, 1, 2
            rangeStart = optionValueIndex;
          } else if (operation === V1_CONTROL_CHARS.OPTION) {
            // colon operation indicates that we are moving down to the next layer of option values. e.g. 0:0:0-2 means we traverse down from option1 to option3 and represents [[0,0,0], [0,0,1], [0,0,2]]
            depth++;
          } else {
            if (
              operation === V1_CONTROL_CHARS.SEQUENCE_GAP ||
              (operation === V1_CONTROL_CHARS.END_OF_PREFIX &&
                encodedVariantField[token.index - 1] !==
                  V1_CONTROL_CHARS.END_OF_PREFIX)
            ) {
              // add the current option value to the list of options if we hit a gap in our sequence or we are at the end of our depth and need to move back up
              options.push([...currentOptionValue]);
            }
            if (operation === V1_CONTROL_CHARS.END_OF_PREFIX) {
              // go up an option level, trash the last item in currentOptionValue
              currentOptionValue.pop();
              depth--;
            }
          }
          index = tokenizer.lastIndex;
        }

        // The while loop only iterates control characters, meaning if an encoded string ends with an index it will not be processed.
        const encodingEndsWithIndex = encodedVariantField.match(/\d+$/g);
        if (encodingEndsWithIndex) {
          const finalValueIndex = parseInt(encodingEndsWithIndex[0]);
          if (rangeStart != null) {
            // process final range
            for (; rangeStart <= finalValueIndex; rangeStart++) {
              currentOptionValue[depth] = rangeStart;
              options.push([...currentOptionValue]);
            }
          } else {
            // process final index
            options.push([finalValueIndex]);
          }
        }
        return options;
      }
      if (!encodedVariantField) return [];
      if (encodedVariantField.startsWith('v1_')) {
        return v1Decoder(encodedVariantField.replace(/^v1_/, ''));
      }
      throw new Error('Unsupported option value encoding');
    }
    this.decodedOptionValues = new Map();
    if (optionValueCombination.length === 0) {
      return false;
    }
    if (!this.decodedOptionValues.has(encodedVariantField)) {
      const decodedOptionValuesSet = new Set();

      for (const optionValue of decodeEncodedVariant(encodedVariantField)) {
        // add the complete option value to the decoded option values set
        decodedOptionValuesSet.add(optionValue.join(OPTION_VALUE_SEPARATOR));

        // add all composite parts of the option value to the decoded option values set. e.g. if the option value is [0,1,2], add "0", "0,1", "0,1,2"
        for (let i = 0; i < optionValue.length; i++) {
          decodedOptionValuesSet.add(
            optionValue.slice(0, i + 1).join(OPTION_VALUE_SEPARATOR),
          );
        }
      }
      this.decodedOptionValues.set(encodedVariantField, decodedOptionValuesSet);
    }
    return this.decodedOptionValues.get(encodedVariantField)?.has(optionValueCombination.join(OPTION_VALUE_SEPARATOR));
  };
  renderOptionValue(option, optionIndex, optionValue, optionValueIndex, value_type) {
    const renderedOptionInput =  `<input index="${optionIndex},${optionValueIndex}" id="${optionValue.id.split('/').pop()}" type="radio" class="value-input hidden" name="${option.name}" value="${optionValue.name}">`;
    let renderedOptionLabel = '';
    if(value_type === 'size') {
      renderedOptionLabel = `
        <label for="${optionValue.id.split('/').pop()}" class="value size_value">
          <p>${optionValue?.firstSelectableVariant?.sizeName?.value ?? optionValue?.name}</p>
        </label>
      `
    } else if(value_type === 'color') {
      const swatch_image = optionValue?.firstSelectableVariant?.variantSwatch?.reference?.image?.reference?.image;
      renderedOptionLabel = `
        <label for="${optionValue.id.split('/').pop()}" class="value swatch_value">
          <div class="swatch">
            <img src="${swatch_image.url}" alt="${swatch_image.altText}" width="200" height="200" loading="eager" sizes="50px" srcset="
              ${swatch_image.url}&width=50 50w,
              ${swatch_image.url}&width=&100 100w,
              ${swatch_image.url}&width=&150 150w,
              ${swatch_image.url}&width=&200 200w
            ">
          </div>
        </label>
      `
    } else if (value_type === 'model') {
      let optionSplit = optionValue?.name?.split('|');
      optionSplit?.shift();
      renderedOptionLabel = `
        <label for="${optionValue.id.split('/').pop()}" class="value model_value capitalize">
          <p>${optionSplit?.join('|')?.replaceAll('/', ' / ') ?? ''}</p>
        </label>
      `
    } else {
      let optionSplit = optionValue?.name?.split('|');
      optionSplit?.shift();
      renderedOptionLabel = `
        <label for="${optionValue.id.split('/').pop()}" class="value other_value capitalize">
          <p>${optionSplit?.join('|')?.replaceAll('/', ' / ') ?? ''}</p>
        </label>
      `
    }
    return `${renderedOptionInput}${renderedOptionLabel}`;
  }
  updateOptionValues() {
    const encodedVariantExistence = this.product.encodedVariantExistence;
    const encodedVariantAvailability = this.product.encodedVariantAvailability;
    const selectedValueParents = [];
    this?.product?.options?.forEach((option, optionIndex) => {
      const selectedValue = this.currentVariant?.selectedOptions?.[optionIndex]?.value;
      let selectedValueIndex = 0;
      option?.optionValues?.forEach((optionValue, optionValueIndex) => {
        const optionValueInput = this.querySelector(`input[index="${optionIndex},${optionValueIndex}"]`);
        const checked = selectedValue === optionValue.name;
        const currentValueIndex = [...selectedValueParents, optionValueIndex];
        if(optionValueInput) {
          const exists = this.isOptionValueCombinationInEncodedVariant(currentValueIndex, encodedVariantExistence);
          const available = this.isOptionValueCombinationInEncodedVariant(currentValueIndex, encodedVariantAvailability);
          if(exists) {
            optionValueInput.removeAttribute('disabled');
            if(available) {
              optionValueInput.classList.remove('sold-out');
            } else {
              optionValueInput.classList.add('sold-out');
            }
          } else {
            optionValueInput.setAttribute('disabled', '');
            optionValueInput.classList.remove('sold-out');
          }
          if(checked) {
            optionValueInput.checked = true;
          }
        }
        if(checked) {
          selectedValueIndex = optionValueIndex;
        }
      });
      selectedValueParents.push(selectedValueIndex);
    });
    this.querySelector('product-option-tabs')?.update();
  }
  renderSelector() {
    this.product?.options?.forEach((option, optionIndex) => {
      const optionValuesWrapper =  this.optionsForm.querySelector(`[data-option-id="option${optionIndex+1}"] .values`);
      const value_type = window.Shopify.theme.sizeOptionName.includes(option.name) ? 'size' : window.Shopify.theme.swatchOptionName.includes(option.name) ? 'color' : window.Shopify.theme.variantOptionName.includes(option.name) ? 'model' : 'undefined';
      const sizeTypes = value_type === 'size' ? option.optionValues.map(optionValue => optionValue?.firstSelectableVariant?.sizeType?.value ?? 'undefined').filter((value, index, array) => !!value && array.indexOf(value) === index) : null;
      if(value_type === 'size' && sizeTypes && sizeTypes.length > 1 && (sizeTypes.includes('short') || sizeTypes.includes('regular') || sizeTypes.includes('long')) && !(sizeTypes.length < 3 && sizeTypes.includes('undefined'))) {
        optionValuesWrapper.innerHTML = `
          <product-option-tabs>
            <div class="option-tabs-titles">
              ${sizeTypes.includes('short') ? `
                <div class="size-option-title option-title-short">
                  <p>${window.Shopify?.theme?.translations?.products?.product?.variant_selector?.option_size_short ?? 'missing translation'}</p>
                </div>
              ` : ''}
              ${sizeTypes.includes('regular') ? `
                <div class="size-option-title option-title-regular">
                  <p>${window.Shopify?.theme?.translations?.products?.product?.variant_selector?.option_size_regular ?? 'missing translation'}</p>
                </div>
              ` : ''}
              ${sizeTypes.includes('long') ? `
                <div class="size-option-title option-title-long">
                  <p>${window.Shopify?.theme?.translations?.products?.product?.variant_selector?.option_size_long ?? 'missing translation'}</p>
                </div>
              ` : ''}
              ${sizeTypes.includes('undefined') ? `
                <div class="size-option-title option-title-undefined">
                  <p>${window.Shopify?.theme?.translations?.products?.product?.variant_selector?.option_size_undefined ?? 'missing translation'}</p>
                </div>
              ` : ''}
            </div>
            <div class="option-tabs-contents">
              ${sizeTypes.includes('short') ? `
                <div class="size-option-content option-content-short hidden">
                  ${option.optionValues.map((optionValue, optionValueIndex) => {
                    const sizeType = optionValue?.firstSelectableVariant?.sizeType?.value;
                    return sizeType === 'short' ? this.renderOptionValue(option, optionIndex, optionValue, optionValueIndex, value_type) : '';
                  }).join('')}
                </div>  
              ` : ''}
              ${sizeTypes.includes('regular') ? `
                <div class="size-option-content option-content-regular hidden">
                  ${option.optionValues.map((optionValue, optionValueIndex) => {
                    const sizeType = optionValue?.firstSelectableVariant?.sizeType?.value;
                    return sizeType === 'regular' ? this.renderOptionValue(option, optionIndex, optionValue, optionValueIndex, value_type) : '';
                  }).join('')}
                </div>  
              ` : ''}
              ${sizeTypes.includes('long') ? `
                <div class="size-option-content option-content-long hidden">
                  ${option.optionValues.map((optionValue, optionValueIndex) => {
                    const sizeType = optionValue?.firstSelectableVariant?.sizeType?.value;
                    return sizeType === 'long' ? this.renderOptionValue(option, optionIndex, optionValue, optionValueIndex, value_type) : '';
                  }).join('')}
                </div>  
              ` : ''}
              ${sizeTypes.includes('undefined') ? `
                <div class="size-option-content option-content-undefined hidden">
                  ${option.optionValues.map((optionValue, optionValueIndex) => {
                    const sizeType = optionValue?.firstSelectableVariant?.sizeType?.value;
                    return sizeType !== 'short' && sizeType !== 'regular' && sizeType !== 'long' ? this.renderOptionValue(option, optionIndex, optionValue, optionValueIndex, value_type) : '';
                  }).join('')}
                </div>  
              ` : ''}
            </div>
          </product-option-tabs>
        `;
      } else {
        optionValuesWrapper.innerHTML = `
          ${option.optionValues.map((optionValue, optionValueIndex) => this.renderOptionValue(option, optionIndex, optionValue, optionValueIndex, value_type)).join('')}
        `;
      }
    });
  }
  setEventListeners() {
    const options = this.querySelectorAll('.option');
    const openToggles = this.section.querySelectorAll('[data-open-option]');
    const closeToggles = this.section.querySelectorAll('[data-close-option]');
    const closeAllToggles = this.section.querySelectorAll('[data-close-all]');
    const valueInputs = this.querySelectorAll('input.value-input');
    openToggles.forEach(toggle => {
      toggle.addEventListener('click', event => {
        const openOption = this.querySelector('.option.'+toggle.dataset.openOption);
        if (openOption != null && openOption.classList.contains('active')) {
          options.forEach(option => {
            this.closeOption(option);
          });
          this.enableScroll(openOption);
        }
        else {
          options.forEach(option => {
            this.closeOption(option);
          });
          this.openOption(openOption);
          this.disableScroll();
        }
      });
    });
    closeToggles.forEach(toggle => {
      toggle.addEventListener('click', event => {
        const closeOption = this.querySelector('.option.'+toggle.dataset.closeOption);
        if(closeOption) {
          this.closeOption(closeOption);
        }
        this.enableScroll();
      });
    });
    closeAllToggles.forEach(toggle => {
      toggle.addEventListener('click', event => {
        options.forEach(option => {
          this.closeOption(option);
        });
        this.enableScroll();
      });
    });
    valueInputs.forEach((valueInput) => {
      valueInput.addEventListener('input', (e) => {
        const formData = new FormData(this.optionsForm);
        const optionName = e.target.getAttribute('name');
        const selectedOptions = Array.from(formData.entries()).map(([key, value]) => ({name: key, value: value}));
        this.selectedOptions = this.validateSelectedOptions(selectedOptions);
        if(window.Shopify.theme.swatchOptionName.includes(optionName) || window.Shopify.theme.variantOptionName.includes(optionName)) {
          this.updateImages();
        }
        this.updateVariant();
      });
    });
  }
  validateSelectedOptions(selectedOptions) {
    // check if selection leads to existing variant
    const encodedVariantExistence = this.product.encodedVariantExistence;
    let selectedOptionIndices = this.product.options.map((option, optionIndex) => option?.optionValues?.findIndex(optionValue => optionValue?.name === selectedOptions?.[optionIndex]?.value));
    if(this.isOptionValueCombinationInEncodedVariant(selectedOptionIndices, encodedVariantExistence)) {
      return selectedOptions;
    } else {
      // option combination is invalid -> find a variant that is close to the current option selection
      for (let i = selectedOptionIndices.length-1; i > 0; i--) {
        if(this.isOptionValueCombinationInEncodedVariant(selectedOptionIndices.slice(0, i), encodedVariantExistence)) {
          for(let j = i; j < selectedOptionIndices.length; j++) {
            const option = this.product?.options?.[j];
            for(let k = 0; k < option.optionValues.length; k++) {
              selectedOptionIndices[j] = k;
              if(this.isOptionValueCombinationInEncodedVariant(selectedOptionIndices.slice(0, j+1), encodedVariantExistence)) {
                break;
              }
            }
          }
          break;
        }
      }
      return selectedOptionIndices.map((value, index) => ({name: this.product.options[index].name, value: this.product.options[index].optionValues[value].name}));
    }
  }
  async updateVariant() {
    this.updateDeeplinking();
    this.classList.add('loading');
    await this.getVariantData();
    this.updateOptionValues();
    this.updateButtons();
    this.updateSku();
    this.updatePickupAvailability();
    this.updateAddToCartButton();
    this.updateVariantInput();
    this.updateVariantTitle();
    this.updatePrice();
    this.updateBackorderText();
    this.classList.remove('loading');
    this.dispatchEvent(new CustomEvent('on:variant:change', {bubbles: true, detail: {form: this.productForm, variant: this.currentVariant, product: this.product}}));
  }
  formatMoneyLocalized(amount) {
    if (window.Shopify.country === 'RS') {
      return new Intl.NumberFormat('sr-RS', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount / 100) + ' RSD';
    }

    return Shopify.theme.formatMoney(amount);
  }
  updatePrice() {
    this.price = this.section.querySelector('.product-info__price > .price');
    this.scalePrice = this.section.querySelector('.product-price .scalePrice');
    const currentPrice = this.currentVariant?.price?.amount ? Math.round(Number(this.currentVariant.price.amount) * 100.0) : 0;
    const currentComparePrice = this.currentVariant?.compareAtPrice?.amount ? Math.round(Number(this.currentVariant.compareAtPrice.amount) * 100.0) : 0;
    const currentUnitPrice = this.currentVariant?.unitPrice?.amount ? Math.round(Number(this.currentVariant.unitPrice.amount) * 100.0) : 0;
    const scalePriceJson = window.Shopify.country == "RS" ? 
      (this.currentVariant?.scalePricesSerbia?.value ? JSON.parse(this.currentVariant.scalePricesSerbia.value) : null):
      (this.currentVariant?.scalePricesDefault?.value ? JSON.parse(this.currentVariant.scalePricesDefault.value) : null);

    if (!this.price) return;
    if (this.currentVariant) {
      const priceCurrentEl = this.price.querySelector('.price__current[data-vat="with-vat"]');
      const priceWasEl = this.price.querySelector('.price__was[data-vat="with-vat"]');
      const priceCurrentNoVatEl = this.price.querySelector('.price__current[data-vat="no-vat"]');
      const priceWasNoVatEl = this.price.querySelector('.price__was[data-vat="no-vat"]');
      const unitPriceEl = this.price.querySelector('.unit-price');

      // Update current price and original price if on sale.
      if (priceCurrentEl) priceCurrentEl.innerHTML = currentPrice ? this.formatMoneyLocalized(currentPrice * window.Shopify.theme.vatMultiplier) : Shopify.theme.formatMoney(0);
      if (priceWasEl) priceWasEl.innerHTML = currentComparePrice && currentComparePrice > currentPrice ? this.formatMoneyLocalized(currentComparePrice * window.Shopify.theme.vatMultiplier) : '';
      if (priceCurrentNoVatEl) priceCurrentNoVatEl.innerHTML = currentPrice ? this.formatMoneyLocalized(currentPrice) : Shopify.theme.formatMoney(0);
      if (priceWasNoVatEl) priceWasNoVatEl.innerHTML = currentComparePrice && currentComparePrice > currentPrice ? this.formatMoneyLocalized(currentComparePrice) : '';

      // Update unit price, if specified.
      if (currentUnitPrice) {
        const valueEl = this.price.querySelector('.unit-price__price');
        const unitEl = this.price.querySelector('.unit-price__unit');
        const value = this.currentVariant.unit_price_measurement.reference_value;
        const unit = this.currentVariant.unit_price_measurement.reference_unit;
        valueEl.innerHTML = this.formatMoneyLocalized(currentUnitPrice);
        unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
      }

      //scale price, if specified
      if (this.scalePrice) {
        if(scalePriceJson && scalePriceJson.scale_prices && scalePriceJson.scale_prices.length > 1) {
          this.scalePrice.classList.remove('hidden');
          var scalePriceData = scalePriceJson.scale_prices;
          scalePriceData.forEach(scalePrice => {
            if(scalePrice.price && scalePrice.quantity > 1) {
              const spWithVat = this.formatMoneyLocalized(scalePrice.price * 100.0 * window.Shopify.theme.vatMultiplier);
              const spWithoutVat = this.formatMoneyLocalized(scalePrice.price * 100.0);
              const spWithVatNode = this.scalePrice.querySelector(`[data-vat="with-vat"] [data-quantity="${ scalePrice.quantity }"] .price`);
              const spWithoutVatNode = this.scalePrice.querySelector(`[data-vat="no-vat"] [data-quantity="${ scalePrice.quantity }"] .price`)
              if(spWithVatNode && spWithVat) {
                spWithVatNode.innerHTML = spWithVat;
              }
              if(spWithoutVatNode && spWithoutVat) {
                spWithoutVatNode.innerHTML = spWithoutVat;
              }
            }
          })
        } else {
          this.scalePrice.classList.add('hidden');
        }
      }

      unitPriceEl.hidden = !currentUnitPrice;
      this.price.classList.toggle('price--on-sale', currentComparePrice > currentPrice);
      this.price.classList.toggle('price--sold-out', !this.currentVariant.availableForSale);
    }

    this.price.querySelector('.price__default').hidden = !this.currentVariant;
    this.price.querySelector('.price__no-variant').hidden = this.currentVariant;
  }
  updateBackorderText() {
    this.backorder = this.section.querySelector('.backorder');
    if (!this.backorder) return;
    let hideBackorder = true;
    if (this.currentVariant && this.currentVariant.availableForSale) {
      if (this.currentVariant.currentlyNotInStock) {
        const backorderProdEl = this.backorder.querySelector('.backorder__product');
        const prodTitleEl = this.section.querySelector('.product-title');
        const variantTitle = this.currentVariant.title.includes('Default') ? '' : ` - ${this.currentVariant.title}`;
        backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
        hideBackorder = false;
      }
    }
    this.backorder.hidden = hideBackorder;
  }
  updateVariantTitle() {
    this.product?.options?.forEach((option, index) => {
      const optionId = 'option'+(index+1);
      const isColor = window.Shopify.theme.swatchOptionName.includes(option.name);
      const currentVariantTitleNodes = this.section.querySelectorAll(`[data-option-id="${optionId}"] [data-variant-title]`);
      currentVariantTitleNodes?.forEach(currentVariantTitleNode => {
        if(isColor){
          let colorName = this.currentVariant?.variantSwatch?.reference?.name?.value ?? null;
          if(colorName){
            colorName = colorName?.replaceAll('"', '`')?.split('|')?.pop()?.replaceAll('/', ' / ')?.replaceAll('+', ' + ');
            currentVariantTitleNode.innerHTML = colorName;
          }
        }else{
          let optionSplit =  this.currentVariant?.selectedOptions?.[index]?.value?.split('|');
          optionSplit?.shift();
          currentVariantTitleNode.innerHTML = optionSplit?.join('|')?.replaceAll('/', ' / ') ?? '';
        } 
      });
    });
  }
  updateVariantInput() {
    const variantIdInput = this.productForm?.querySelector('input[name="id"]');
    if (!!variantIdInput) {
      variantIdInput.value = this.currentVariant.id;
      variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  updateAddToCartButton() {
    if (!this.productForm) return;
    this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
    const variantAvailable = this.currentVariant && this.currentVariant.availableForSale;
    const unavailableStr = this.currentVariant ? theme.strings.noStock : theme.strings.noVariant;
    this.addBtn.disabled = !variantAvailable;
    this.addBtn.textContent = variantAvailable ? this.addBtn.dataset.addToCartText : unavailableStr;
  }
  updateDeeplinking(initial = false) {
    let checkedOptions = null;
    if (initial && this.productForm) {
      checkedOptions = this.productForm.querySelector('input[name="option_values"]')?.value ?? null;
    } else if(this.optionsForm) {
      checkedOptions = this.product.options.map((option, optionIndex) => option?.optionValues?.find(optionValue => optionValue?.name === this.selectedOptions?.[optionIndex]?.value)?.id.split('/')?.pop());
    }
    const newUrl = new URL(document.location);
    newUrl.searchParams.delete('variant');
    newUrl.searchParams.set('option_values', checkedOptions);
    window.history.replaceState(null, '', newUrl.href);
  }
  updatePickupAvailability() {
    this.pickUpAvailability = this.section.querySelector('pickup-availability');
    if (!this.pickUpAvailability) return;
    if (this.currentVariant && this.currentVariant.availableForSale) {
      this.pickUpAvailability.getAvailability(this.currentVariant.id);
    } else {
      this.pickUpAvailability.removeAttribute('available');
      this.pickUpAvailability.innerHTML = '';
    }
  }
  updateButtons(){
    this.product?.options?.forEach((option, index) => {
      const optionId = `option${index+1}`;
      const isSize = window.Shopify.theme.sizeOptionName.includes(option.name);
      const isColor = window.Shopify.theme.swatchOptionName.includes(option.name);
      document.querySelectorAll(`[data-${optionId}-value]`).forEach(optionValueNode => {
        if(isColor){
          let colorName = this.currentVariant?.variantSwatch?.reference?.name?.value ?? null;
          if(colorName){
            colorName = colorName?.replaceAll('"', '`')?.split('|')?.pop()?.replaceAll('/', ' / ')?.replaceAll('+', ' + ');
            optionValueNode.innerHTML = colorName;
          }
        } else if(isSize) {
          const sizeName = this.currentVariant?.sizeName?.value ?? null;
          if(sizeName) {
            optionValueNode.innerHTML = sizeName;
          }
        } else {
          const optionValueNameSplit = this.currentVariant?.selectedOptions?.find(o => o.name === option.name)?.value.split('|');
          optionValueNameSplit.shift();
          if(optionValueNameSplit) {
            optionValueNode.innerHTML = optionValueNameSplit?.join('|')?.replaceAll('/', ' / ') ?? '';
          }
        }
      });
      document.querySelectorAll(`[data-open-option="${optionId}"] .swatch`).forEach(swatch => {
        const swatch_image = this.currentVariant?.variantSwatch?.reference?.image?.reference?.image ?? null;
        swatch.innerHTML = swatch_image ? `
          <img src="${swatch_image.url}" alt="${swatch_image.altText}" width="200" height="200" loading="eager" sizes="50px" srcset="
            ${swatch_image.url}&width=50 50w,
            ${swatch_image.url}&width=&100 100w,
            ${swatch_image.url}&width=&150 150w,
            ${swatch_image.url}&width=&200 200w
          ">
        `: '';
      });
    });
  }
  updateSku() {
    this.sku = this.section.querySelector('.product-sku__value');
    if (!this.sku) return;
    const skuAvailable = this.currentVariant && this.currentVariant.sku;
    this.sku.innerHTML = skuAvailable ? `#${this.currentVariant.sku.split('-')[0]}` : '';
    this.sku.parentNode.hidden = !skuAvailable;
  }
  updateImages() {
    const sectionId = this.section.dataset.section;
    const checkedOptions = this.product?.options?.map((option, optionIndex) => option?.optionValues?.find(optionValue => optionValue?.name === this.selectedOptions?.[optionIndex]?.value)?.id.split('/')?.pop());
    const params = new URL(document.location).searchParams;
    params.set('option_values', checkedOptions);
    params.set('sections', sectionId);
    const newUrl = new URL(document.location);
    newUrl.search = params.toString();
    fetch(newUrl.href, {
      credentials: 'same-origin',
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      method: 'GET'
    })
    .then(response => response.json())
    .then(data => {
      if(!data[sectionId]) {
        return;
      }
      let template = document.createElement('template');
      template.innerHTML = data[sectionId]?.trim();
      const oldProductImages = document.querySelector('#product-media');
      const newProductImages = template.content.querySelector('#product-media');
      if(!!oldProductImages && newProductImages){
        oldProductImages.replaceWith(newProductImages);
      }
    })
    .catch(function(err) {
        console.error(err);
    });
  }
}
customElements.define('variant-selector', VariantSelector);

function handleClickOutside(event){
  let variantSelector = document.querySelector('variant-selector');
  if(!!variantSelector){
    const active_options = variantSelector.querySelectorAll('.option.active');
    const toggle = event.target.hasAttribute('data-open-option') || event.target.closest('[data-open-option]');
    if(active_options.length > 0 && !variantSelector.contains(event.target) && !toggle){
      active_options.forEach(option => {
        variantSelector.closeOption(option);
      });
      variantSelector.enableScroll();
    }
  }
}
document.body.addEventListener('click', handleClickOutside);

class ProductOptionTabs extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }
  hideAll() {
    const titles = this.querySelectorAll('.size-option-title');
    const contents = this.querySelectorAll('.size-option-content');
    titles.forEach(title => {
      title.classList.remove('active');
    });
    contents.forEach(content => {
      content.classList.add('hidden');
    });
  }
  update() {
    if(this.sizeTypeContentShort?.querySelector('input:checked')) {
      this.hideAll();
      this.sizeTypeTitleShort.classList.add('active');
      this.sizeTypeContentShort.classList.remove('hidden');
    }
    if(this.sizeTypeContentRegular?.querySelector('input:checked')) {
      this.hideAll();
      this.sizeTypeTitleRegular.classList.add('active');
      this.sizeTypeContentRegular.classList.remove('hidden');
    }
    if(this.sizeTypeContentLong?.querySelector('input:checked')) {
      this.hideAll();
      this.sizeTypeTitleLong.classList.add('active');
      this.sizeTypeContentLong.classList.remove('hidden');
    }
    if(this.sizeTypeContentUndefined?.querySelector('input:checked')) {
      this.hideAll();
      this.sizeTypeTitleUndefined.classList.add('active');
      this.sizeTypeContentUndefined.classList.remove('hidden');
    }
    if(this.sizeTypeContentShort?.querySelector('input:not([disabled])')) {
      this.sizeTypeTitleShort.classList.remove('hidden');
    } else {
      this.sizeTypeTitleShort?.classList?.add('hidden');
    }
    if(this.sizeTypeContentRegular?.querySelector('input:not([disabled])')) {
      this.sizeTypeTitleRegular.classList.remove('hidden');
    } else {
      this.sizeTypeTitleRegular?.classList?.add('hidden');
    }
    if(this.sizeTypeContentLong?.querySelector('input:not([disabled])')) {
      this.sizeTypeTitleLong.classList.remove('hidden');
    } else {
      this.sizeTypeTitleLong?.classList?.add('hidden');
    }
    if(this.sizeTypeContentUndefined?.querySelector('input:not([disabled])')) {
      this.sizeTypeTitleUndefined.classList.remove('hidden');
    } else {
      this.sizeTypeTitleUndefined?.classList?.add('hidden');
    }
  }
  init() {
    this.sizeTypeTitleShort = this.querySelector('.option-title-short');
    this.sizeTypeTitleRegular = this.querySelector('.option-title-regular');
    this.sizeTypeTitleLong = this.querySelector('.option-title-long');
    this.sizeTypeTitleUndefined = this.querySelector('.option-title-undefined');
    this.sizeTypeContentShort = this.querySelector('.option-content-short');
    this.sizeTypeContentRegular = this.querySelector('.option-content-regular');
    this.sizeTypeContentLong = this.querySelector('.option-content-long');
    this.sizeTypeContentUndefined = this.querySelector('.option-content-undefined');
    this.sizeTypeTitleShort?.addEventListener('click', event => {
      this.hideAll();
      this.sizeTypeTitleShort.classList.add('active');
      this.sizeTypeContentShort.classList.remove('hidden');
    });
    this.sizeTypeTitleRegular?.addEventListener('click', event => {
      this.hideAll();
      this.sizeTypeTitleRegular.classList.add('active');
      this.sizeTypeContentRegular.classList.remove('hidden');
    });
    this.sizeTypeTitleLong?.addEventListener('click', event => {
      this.hideAll();
      this.sizeTypeTitleLong.classList.add('active');
      this.sizeTypeContentLong.classList.remove('hidden');
    });
    this.sizeTypeTitleUndefined?.addEventListener('click', event => {
      this.hideAll();
      this.sizeTypeTitleUndefined.classList.add('active');
      this.sizeTypeContentUndefined.classList.remove('hidden');
    });
  }
}
customElements.define('product-option-tabs', ProductOptionTabs);
